// WebSocket protocol (04 §7).
import { z } from 'zod';

export const serverFrameSchema = z.object({
  seq: z.number().int(), // per account, increasing; gaps are normal (02 §4.3)
  event: z.string(), // 04 §7.4
  channel: z.string(),
  payload: z.unknown(),
  sentAt: z.iso.datetime(),
});
export type ServerFrame = z.infer<typeof serverFrameSchema>;

export const clientFrameSchema = z.discriminatedUnion('type', [
  z.object({ type: z.literal('PING'), clientTime: z.number() }),
  z.object({ type: z.literal('SUBSCRIBE'), channel: z.string(), correlationId: z.string() }),
  z.object({ type: z.literal('UNSUBSCRIBE'), channel: z.string() }),
  z.object({ type: z.literal('RESUME'), lastSequenceId: z.number().int() }),
]);
export type ClientFrame = z.infer<typeof clientFrameSchema>;

/** Close codes (04 §7.1). */
export const WS_CLOSE = {
  INVALID_WS_TICKET: 4401,
  FORBIDDEN: 4403,
  IDLE_TIMEOUT: 4408,
  CONNECTION_REPLACED: 4409,
} as const;

/** Frames the hub sends on its own (not from the outbox). */
export const PROTOCOL_EVENTS = [
  'CONNECTION_READY',
  'SUBSCRIBED',
  'SUBSCRIBE_DENIED',
  'PONG',
  'FORCE_RESYNC_REQUIRED',
] as const;

export const connectionReadyPayloadSchema = z.object({
  sessionId: z.string(),
  lastSequenceId: z.number().int(),
  serverTime: z.iso.datetime(),
});

/** Channel names (04 §7.3). */
export const channels = {
  player: (playerId: string) => `player:${playerId}`,
  account: (accountId: string) => `account:${accountId}`,
  galaxy: (galaxyId: string) => `galaxy:${galaxyId}`,
  alliance: (allianceId: string) => `alliance:${allianceId}`,
  allianceIntel: (allianceId: string) => `alliance-intel:${allianceId}`,
  system: (systemId: string) => `system:${systemId}`,
  battle: (battleId: string) => `battle:${battleId}`,
} as const;
